export const LANGUAGES = {
    ES: "es",
    EN: "en",
    GL: "gl"

};
